var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClansmartLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 45,
    viewBox: "0 0 70 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 22.5C45 34.9264 34.9263 45 22.5 45C10.0737 45 0 34.9264 0 22.5C0 10.0736 10.0737 0 22.5 0C34.9263 0 45 10.0736 45 22.5Z",
    fill: "#68DBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2647 22.5C69.2647 34.9264 59.2898 45 46.9853 45C34.6808 45 24.7058 34.9264 24.7058 22.5C24.7058 10.0736 34.6808 0 46.9853 0C59.2898 0 69.2647 10.0736 69.2647 22.5Z",
    fill: "#FF7917"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8029 41.3416C40.9433 37.3239 45 30.3858 45 22.5C45 14.6144 40.9433 7.67614 34.8029 3.65854C28.7228 7.67614 24.7058 14.6144 24.7058 22.5C24.7058 30.3858 28.7228 37.3239 34.8029 41.3416Z",
    fill: "#5D2C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClansmartLogo);
export default __webpack_public_path__ + "static/media/clansmartLogo.34b4f4e9013150f6eb107f3494531a3f.svg";
export { ForwardRef as ReactComponent };